import RemoveButton from './RemoveButton';

export default RemoveButton;
export { RemoveButton };
